const styles = theme => ({
  thumbnail : {
    width: 150
  }
});

export default styles;